import { render } from "./View03.vue?vue&type=template&id=05bb954d"
import script from "./View03.vue?vue&type=script&lang=js"
export * from "./View03.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__